import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import classnames from 'classnames';

import {
  LISTING_PHOTO_DIMENSION_THUMBNAIL,
} from 'common/listingConstants';

import {
  getListingManagedPhotoUrls,
} from 'common/listingHelpers';

import {
  LEAD_ACTIVITY_BOOKMARK,
  LEAD_ACTIVITY_CHECK_AVAILABILITY,
  LEAD_ACTIVITY_ASSIGNED,
} from 'common/leadConstants';

import {
  getFormattedFromNowDate,
  getAutoTextStatus,
} from 'common/formatters';

@withRouter
class SrAgentLeadsActivityRow extends Component {
  static propTypes = {
    activity: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    source: PropTypes.string.isRequired,
    listingPhotoResolution: PropTypes.number.isRequired,
  };

  _onRowClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const {
      activity,
      source,
      history,
    } = this.props;

    if (activity.activityType === LEAD_ACTIVITY_ASSIGNED) {
      history.push(
        `/agent/lead/${encodeURIComponent(activity.renterUserId)}` +
        `?activity_id=${encodeURIComponent(activity.id)}` +
        `&source=${encodeURIComponent(source)}`
      );
    }
    else {
      history.push(
        `/listing/${activity.listingId}` +
        `?activity_id=${encodeURIComponent(activity.id)}` +
        `&activityType=${encodeURIComponent(activity.activityType)}` +
        `&leadName=${encodeURIComponent(activity.renterName.split(' ')[0])}` +
        `&leadUserId=${encodeURIComponent(activity.renterUserId)}` +
        `&source=${encodeURIComponent(source)}`
      );
    }
  };

  render() {
    const {
      activity,
      listingPhotoResolution,
    } = this.props;

    const activityString = activity.activityType === LEAD_ACTIVITY_CHECK_AVAILABILITY
      ? (
        ' clicked "Check Availability" on'
      ) : (
        activity.activityType === LEAD_ACTIVITY_BOOKMARK
          ? (
            ' saved'
          )
          : (
            ' is a new lead!'
          )
      );

    const apartmentNameString = activity.activityType === LEAD_ACTIVITY_ASSIGNED
      ? ''
      : (
        activity.apartmentName
          ? ` ${activity.apartmentName}`
          : ` ${activity.addressStreetDisplay}`
      );
    const dateStr = getFormattedFromNowDate({ date: activity.createdDate });

    /**
    * Reconstructs the 'activity' associated with this component
    * into a new array since the function 'getAutoTextStatus'
    * takes an array for the paramater 'renterActivity'
    */
    const reconstructedRenterActivity = [{
      id: activity.id,
      activityType: activity.activityType,
      customProps: activity.customProps,
    }];

    const autoTextStr = getAutoTextStatus({
      renterActivity: reconstructedRenterActivity,
      frontAutoText: activity.frontAutoText,
    });

    let managedPhotoUrls = null;

    if (activity.activityType !== LEAD_ACTIVITY_ASSIGNED) {
      managedPhotoUrls = getListingManagedPhotoUrls({
        listing: activity,
        dimension: LISTING_PHOTO_DIMENSION_THUMBNAIL,
        resolution: listingPhotoResolution,
      });
    }

    return (
      <div
        className={classnames(
          'leadActivityRowContainer',
          { seen: activity.seen }
        )}
        onClick={this._onRowClick}
      >
        <div className='leadActivityContent'>
          <div className='leadActivityTopRow'>
            <span
              className='leadName'
              to={`/agent/lead/${activity.renterUserId}`}
            >
              {activity.renterName}
            </span>
            <span
              className='leadActivityAction'
            >
              {activityString}
            </span>
            <span>
              {apartmentNameString}
            </span>
          </div>
          <div className='leadActivityBottomRow'>
            <span className={classnames('leadActivityIcon', activity.activityType)} />
            <span
              className='leadActivityDate'
            >
              {dateStr}
            </span>
            {activity.activityType === LEAD_ACTIVITY_ASSIGNED && (
              <span>
                <span className='leadActivityBottomRowDot'>
                  •
                </span>
                <span>
                  Autotext: {autoTextStr}
                </span>
              </span>
            )}
          </div>
        </div>
        <div>
          {managedPhotoUrls && (
            <span
              className='thumbnail'
              style={{ backgroundImage: `url("${managedPhotoUrls[0]}")` }}
            />
          )}
        </div>
      </div>
    );
  }
}

SrAgentLeadsActivityRow.displayName = 'SrAgentLeadsActivityRow';

export default SrAgentLeadsActivityRow;
